'use strict';

angular.module('staticHtmlPageControllers')

.controller('StaticHtmlPageController', ['$scope', 'topBar', 'page', function ($scope, topBar, page) {

    $scope.page = page;

    topBar.setTitleAndIcon(page.Title, page.TitleIconName);
}]);